import React, {
    useContext
} from 'react';
import {
    Context
} from 'shared/context/GlobalState';
import AvatarDropdownMenu from 'shared/components/AvatarDropdownMenu';
import {
    httpRequest
} from 'shared/utils/httpsRequest';

// Refactor: organize methods and variables orders
export default function Profile() {
    // Constants
    const PROFILE_MENU_ITEMS = [
        {
            name: 'My Account',
            link: '/profile' ,
            action: () =>{}
        },
        {
            name: 'Logout',
            link: undefined,
            action: () => handleLogOut()
        }
    ];

    const {
        user
    } = useContext(Context);

    const handleLogOut = () => { // Refactor: this function to use the GlobalState context
        httpRequest.post('/auth/logout')
            .then(() => {

                //   localStorage.removeItem('selectedSubOrg');

                // navigate('/auth/login');
                window.location = '/auth/login';
            }).catch(() => {

            });
    };

    return (
        <div className={'profile-container'}>
            <AvatarDropdownMenu
                user={user}
                menuItems={PROFILE_MENU_ITEMS} />
        </div>
    );
}